/**
 * Percent as units are strange..
 */

export const percentBaseUnit = 'percent';

export const percentAliases = ['%'] as const;
export const percentUnits = [percentBaseUnit, ...percentAliases] as const;
export const percentUnitSet: Set<string> = new Set(percentUnits);
export const isPercentUnit = (unit: string): unit is PercentUnit =>
  percentUnitSet.has(unit);

export type PercentBaseUnit = typeof percentBaseUnit;
export type PercentAliasUnit = (typeof percentAliases)[number];
export type PercentUnit = PercentBaseUnit | PercentAliasUnit;
